// extracted by mini-css-extract-plugin
export default {"card1":"Card_card1__fBdL9"};